import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Signup1 from './Signup1';
import Signup2 from './Signup2';
import OtpVerification from './OtpVerification';

class Signup extends Component {
  constructor() {
    super();
    this.state = {
      signup1CompletedVal: false
    }
  }

  // shouldComponentUpdate = (nextProps, nextState) => {
  //   return nextState;
  // }

  render() {
    return (
      <div className="row col-md-12 p-0 m-0">
        <div className="col-md-5">
            <Switch>
              {<Route path='/signup/step1' component={Signup1}></Route>}
              <Route path='/signup/step2' component={Signup2}></Route>
              <Route path='/signup/otpverification' component={OtpVerification}></Route>
            </Switch>
        </div>
        <div className="col-md-7 pay2-bg" />
      </div>
    );
  }
}

export default Signup;


// WEBPACK FOOTER //
// ./src/signup/Signup.js